module.exports = __webpack_public_path__ + "img/logo5_and_text_transparent.de683c76.png";